const horizontalScrollPlugin = {
    install(app) {
        const setupInfiniteScroll = (el) => {

            if( el._isScrollInited || ! el.classList.contains('line-scroll') )
                return;

            const content = el.innerHTML;
            el.innerHTML = `<div class="scroll-track">${content}${content}</div>`;
            const track = el.querySelector('.scroll-track');

            let scrollPos = 0;
            let targetPos = 0;
            let isPaused  = false;
            let animationId       = null;

            // функция получения актуальной скорости
            const getSpeed = () => +(el.getAttribute('data-speed')) || 1.5;

            const animate = () => {

                if( ! isPaused )
                    targetPos += getSpeed();

                scrollPos += (targetPos - scrollPos) * 0.1;

                // Зацикливание логики
                const halfWidth = track.scrollWidth / 2;
                if (targetPos >= halfWidth) {
                    targetPos -= halfWidth;
                    scrollPos -= halfWidth;
                }
                if (targetPos < 0) {
                    targetPos += halfWidth;
                    scrollPos += halfWidth;
                }

                el.scrollLeft = scrollPos;
                animationId = requestAnimationFrame( animate );
            };

            // обработка колесика (Wheel)
            el.addEventListener( 'wheel', (e) => {
                if (e.deltaY !== 0) {
                    e.preventDefault();
                    isPaused = true;
                    targetPos += e.deltaY * 1.5;
                    clearTimeout(el._wheelTimeout);
                    el._wheelTimeout = setTimeout(() => {
                        if (!el._isHovered) isPaused = false;
                    }, 800);
                }
            }, { passive: false } );

            // пауза при наведении на .line-scroll-item
            el.addEventListener('mouseover', (e) => {
                if( e.target.closest('.line-scroll-item') ) {
                    isPaused = true;
                    el._isHovered = true;
                }
            });

            el.addEventListener('mouseout', (e) => {
                if( e.target.closest('.line-scroll-item') ) {
                    isPaused = false;
                    el._isHovered = false;
                }
            });

            animationId = requestAnimationFrame( animate );
            el._isScrollInited = true;
        };

        const initAll = () => document.querySelectorAll('.line-scroll').forEach( setupInfiniteScroll );
        const observer = new MutationObserver( () => initAll() );
        observer.observe( document.body, { childList: true, subtree: true } );
        initAll();
    }
};

export default horizontalScrollPlugin;
